import { render, staticRenderFns } from "./model-report.vue?vue&type=template&id=3f2d6bdd&"
import script from "./model-report.vue?vue&type=script&lang=ts&"
export * from "./model-report.vue?vue&type=script&lang=ts&"
import style0 from "./model-report.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports